import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function StateSectoralPipelines({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings, onPageTitle, navbarObjectId, isMobile }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
    onPageTitle && onPageTitle(title);
  }, [pageTitle, title, onPageTitle]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content fillpage">
      <div className="content-header">
        <div className="mobile-page-header">
          <h4 className="mobile-page-title">{title}</h4>
          {navbarObjectId && isMobile && (
            <div className="mobile-page-object">
              <QlikObject
                key={`mobile-${navbarObjectId}`}
                id={navbarObjectId}
                height="30px"
                showLoader={false}
              />
            </div>
          )}
        </div>
      </div>

      <div className="container-fluid page-default kpi-row-double table-floor-250 fillpage-body">

        <div className="row justify-content-start fillpage-row">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 fillpage-col">

              {/* TOP band — KPIs (fixed, 8 @ 90px → 2 rows) + charts (fill) */}
              <div className="band band-top">

                {/* KPI row — fixed height */}
                <div className="row justify-content-left band-kpis">

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      {/* KPI: total sectors */}
                      <QlikCard id="jRuxLP" height="var(--kpi-h)" showHeader={false} showMaximize={false} showExport={false} />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      {/* KPI: total streams */}
                      <QlikCard id="WYPZS" height="var(--kpi-h)" showHeader={false} showMaximize={false} showExport={false} />
                    </div>

                </div>

                {/* Charts row — fills the rest of the top band */}
                <div className="row justify-content-left band-charts">

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex flex-column">
                    {/* bar chart 1 */}
                    <div className="row justify-content-center h-100">
                      <div className="col-12 d-flex flex-column">
                        <QlikCard
                          id="KhtHa"
                          height="100%"
                          showHeader={true}
                          showMaximize={false}
                          showExport={true}
                          showPdfExport
                          showImageExport={true}
                          exportImageWidth={1280}
                          exportImageHeight={720}
                          onBeforeExportHandler={async ({ vis, exportType }) => {
                            console.log(vis);
                            if(exportType in { pdf: true, image: true} && vis)
                              await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                          }}
                          onAfterExportHandler={async ({ vis, exportType }) => {
                            console.log('Export type: ', exportType);
                            if(exportType in { pdf: true, image: true})
                              vis.setOptions({ showTitles: false, footnote:"" });
                          }}
                          exportText = {menuItemsStrings.exportText}
                          exportCompletedText = {menuItemsStrings.exportCompletedText}
                          closeBtnText = {menuItemsStrings.closeBtnText}
                          exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                          exportNoObjectText={menuItemsStrings.exportNoObjectText}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex flex-column">
                    {/* bar chart 2 */}
                    <div className="row justify-content-center h-100">
                      <div className="col-12 d-flex flex-column">
                        <QlikCard
                          id="nJZfWJ"
                          height="100%"
                          showHeader={true}
                          showMaximize={false}
                          showExport={true}
                          showPdfExport
                          showImageExport={true}
                          exportImageWidth={1280}
                          exportImageHeight={720}
                          onBeforeExportHandler={async ({ vis, exportType }) => {
                            console.log(vis);
                            if(exportType in { pdf: true, image: true} && vis)
                              await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                          }}
                          onAfterExportHandler={async ({ vis, exportType }) => {
                            console.log('Export type: ', exportType);
                            if(exportType in { pdf: true, image: true})
                              vis.setOptions({ showTitles: false, footnote:"" });
                          }}
                          exportText = {menuItemsStrings.exportText}
                          exportCompletedText = {menuItemsStrings.exportCompletedText}
                          closeBtnText = {menuItemsStrings.closeBtnText}
                          exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                          exportNoObjectText={menuItemsStrings.exportNoObjectText}
                        />
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              {/* BOTTOM band — table */}
              <div className="band band-bottom band-fill">
                <QlikCard
                  id="cTdp"
                  height="100%"
                  showHeader={true}
                  showMaximize={true}
                  showExport={true}
                  onBeforeExportHandler={async ({  }) => {
                      await app.variable.setStringValue('export_link', '1');
                  }}
                  onAfterExportHandler={async ({  }) => {
                      app.variable.setStringValue('export_link', '0');
                  }}
                  exportText = {menuItemsStrings.exportText}
                  exportCompletedText = {menuItemsStrings.exportCompletedText}
                  closeBtnText = {menuItemsStrings.closeBtnText}
                  exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                  exportNoObjectText={menuItemsStrings.exportNoObjectText}
                  actionsVisibility="always"
                  copyCells="true"
                  copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
                  copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
                />
              </div>

            </div>


            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing fillpage-col">

              {/* TOP band — FilterPane (mirrors KPIs + charts band) */}
              <div className="band band-top filter-col">
                <div className="filter-grow">
                  <QlikCard
                    id="WNHjQ"
                    height="100%"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
              </div>

              {/* BOTTOM band — selector + columns-selector (mirrors table band) */}
              <div className="band band-bottom filter-col">
                {/* Selector — static, sticks to top of the band */}
                <div className="band-fixed">
                  <QlikObject
                    id="9cfdec4b-f38d-493f-8f70-bda4f6cbb2b1"
                    height="var(--selector-h)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
                {/* Columns Selector — fills the rest of the bottom band */}
                <div className="filter-grow">
                  <QlikCard
                    id="wxDwDZP"
                    height="100%"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
              </div>

            </div>

          </div>

          {/* hidden export helper — outside the fill row */}
          <div className="row m-0">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="UGms"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>

        </div>
    </section>
  );
}